import styled from "styled-components";

import { Link } from "react-router-dom";

export const UiSectionBody = styled.div.attrs({
  className: "flex min-w-0 flex-col gap-4 lg:flex-row lg:items-end lg:justify-between",
})<{ $compact?: boolean }>`
  margin-bottom: ${({ $compact }) => ($compact ? "0.5rem" : "1.5rem")};
`;

export const UiContentStack = styled.div.attrs({ className: "min-w-0 space-y-2.5" })``;

export const UiEyebrowText = styled.p.attrs({
  className: "font-anonymous text-xs uppercase tracking-[0.28em] text-[var(--brand-highlight)]",
})``;

export const UiContentStackSecondary = styled.div.attrs({ className: "space-y-1.5" })``;

export const UiPageHeading = styled.h1.attrs({
  className: "break-words text-2xl font-semibold leading-tight text-[var(--brand-ink)] sm:text-3xl",
})``;

export const UiBodyText = styled.p.attrs({
  className: "max-w-3xl text-[13px] leading-6 text-[var(--brand-muted)]",
})``;

export const UiInfoRow = styled.div.attrs({
  className: "flex flex-wrap items-center gap-2 text-xs text-[var(--brand-muted)]",
})``;

export const UiActionLink = styled(Link).attrs({
  className: "transition hover:text-[var(--brand-ink)]",
})``;

export const UiInlineText = styled.span.attrs({ className: "text-[var(--brand-ink)]" })``;

export const UiSection = styled.div.attrs({
  className:
    "flex w-full min-w-0 flex-col gap-2.5 sm:flex-row sm:flex-wrap lg:w-auto lg:justify-end [&>*]:w-full sm:[&>*]:w-auto",
})``;

export const UiSectionHeader = styled.div.attrs({
  className:
    "mb-4 flex min-w-0 flex-col gap-3 pb-4 lg:flex-row lg:items-end lg:justify-between [&>*:last-child]:w-full sm:[&>*:last-child]:w-auto",
})``;

export const UiContentStackTertiary = styled.div.attrs({ className: "min-w-0 space-y-1" })``;

export const UiSectionHeading = styled.h2.attrs({
  className: "break-words text-lg font-semibold text-[var(--brand-ink)]",
})``;

export const UiTextBlock = styled.p.attrs({ className: "text-[13px] text-[var(--brand-muted)]" })``;

export const UiMediaSurface = styled.div.attrs({
  className: "brand-panel-muted relative overflow-hidden",
})``;

export const UiSectionSecondary = styled.div.attrs({
  className:
    "absolute inset-x-0 top-0 h-1 bg-[rgba(120,167,222,0.7)]",
})``;

export const UiEyebrowTextSecondary = styled.p.attrs({
  className: "font-anonymous text-xs uppercase tracking-[0.22em] text-[var(--brand-cool)]",
})``;

export const UiBodyTextSecondary = styled.p.attrs({
  className:
    "font-display mt-2 break-words text-2xl font-semibold leading-tight text-[var(--brand-ink)] sm:text-[1.8rem]",
})``;

export const UiBodyTextTertiary = styled.p.attrs({
  className: "mt-2 text-[13px] leading-6 text-[var(--brand-muted)]",
})``;

export const UiEmptyStatePanel = styled.div.attrs({
  className:
    "rounded-2xl border border-dashed border-[var(--brand-border)] bg-[rgba(255,255,255,0.03)] px-5 py-10 text-center",
})``;

export const UiTitleHeading = styled.h3.attrs({
  className: "text-base font-semibold text-[var(--brand-ink)] sm:text-lg",
})``;

export const UiBodyTextQuaternary = styled.p.attrs({
  className: "mx-auto mt-2 max-w-xl text-[13px] leading-6 text-[var(--brand-muted)]",
})``;

export const UiSectionTertiary = styled.section.attrs<{
  $surfaceClassName?: string;
}>(({ $surfaceClassName }) => ({
  className: ["brand-panel", $surfaceClassName].filter(Boolean).join(" "),
}))`` as any;

export const UiInlineTextSecondary = styled.span.attrs<{
  $palette: string;
}>(({ $palette }) => ({
  className: `inline-flex max-w-full items-center rounded-full border px-2.5 py-1 text-xs font-medium ${$palette}`,
}))`` as any;
